import React from "react";
import { FiChevronLeft, FiChevronRight } from "react-icons/fi";

/* 메뉴관리 페이지네이션 — 공통 Admin UI Kit(Pagination) 룩에 맞춰 재스타일.
 * props/동작/export 는 그대로 유지 (currentPage / totalPages / setCurrentPage). */
const Pagination = ({ currentPage, totalPages, setCurrentPage }) => {
  const numOfPages = Math.ceil(totalPages);
  const nextPage = () =>
    setCurrentPage((prev) => (prev < numOfPages ? prev + 1 : prev));
  const prevPage = () => setCurrentPage((prev) => (prev > 1 ? prev - 1 : prev));

  const getPageNumbers = () => {
    const startPage = Math.max(currentPage - 5, 1);
    const endPage = Math.min(startPage + 9, numOfPages);
    const pages = [];
    for (let i = startPage; i <= endPage; i++) {
      pages.push(i);
    }
    return pages;
  };

  const fontStack =
    "'Pretendard', -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', sans-serif";

  const baseBtn = {
    height: "34px",
    minWidth: "34px",
    padding: "0 8px",
    borderRadius: "8px",
    fontFamily: fontStack,
    fontSize: "13px",
    fontWeight: 600,
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    transition: "background-color .12s ease, border-color .12s ease, color .12s ease",
  };

  const navBtnStyle = (disabled) => ({
    ...baseBtn,
    backgroundColor: "#ffffff",
    color: disabled ? "#98a2b3" : "#344054",
    border: "1px solid #e4e7ec",
    cursor: disabled ? "not-allowed" : "pointer",
  });

  const pageBtnStyle = (active) => ({
    ...baseBtn,
    backgroundColor: active ? "#2563eb" : "#ffffff",
    color: active ? "#ffffff" : "#344054",
    border: `1px solid ${active ? "#2563eb" : "#e4e7ec"}`,
    cursor: active ? "default" : "pointer",
  });

  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        gap: "4px",
      }}
    >
      <button
        onClick={prevPage}
        disabled={currentPage === 1}
        style={navBtnStyle(currentPage === 1)}
        aria-label="이전"
      >
        <FiChevronLeft size={16} />
      </button>
      {getPageNumbers().map((page) => (
        <button
          key={page}
          onClick={() => setCurrentPage(page)}
          disabled={currentPage === page}
          style={pageBtnStyle(currentPage === page)}
        >
          {page}
        </button>
      ))}
      <button
        onClick={nextPage}
        disabled={currentPage === numOfPages}
        style={navBtnStyle(currentPage === numOfPages)}
        aria-label="다음"
      >
        <FiChevronRight size={16} />
      </button>
    </div>
  );
};

export default Pagination;
